'use strict';

var React = require('react');

var SvgLayoutBuyButtonIcon = function SvgLayoutBuyButtonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.25c0-1.519 1.231-2.75 2.75-2.75.414 0 .75.336.75.75s-.336.75-.75.75c-.69 0-1.25.56-1.25 1.25 0 .414-.336.75-.75.75s-.75-.336-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 16.5c-1.519 0-2.75-1.231-2.75-2.75 0-.414.336-.75.75-.75s.75.336.75.75c0 .69.56 1.25 1.25 1.25.414 0 .75.336.75.75s-.336.75-.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.25c0-1.519-1.231-2.75-2.75-2.75-.414 0-.75.336-.75.75s.336.75.75.75c.69 0 1.25.56 1.25 1.25 0 .414.336.75.75.75s.75-.336.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.75c0 1.519-1.231 2.75-2.75 2.75-.414 0-.75-.336-.75-.75s.336-.75.75-.75c.69 0 1.25-.56 1.25-1.25 0-.414.336-.75.75-.75s.75.336.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-2c-.414 0-.75.336-.75.75s.336.75.75.75h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 15.75c0 .414-.336.75-.75.75h-2c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2c.414 0 .75.336.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 7.5c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5h8c1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5h-8Zm-1 2.5c0-.552.448-1 1-1h8c.552 0 1 .448 1 1s-.448 1-1 1h-8c-.552 0-1-.448-1-1Z"
  }));
};
SvgLayoutBuyButtonIcon.displayName = "LayoutBuyButtonIcon";

exports.SvgLayoutBuyButtonIcon = SvgLayoutBuyButtonIcon;
